import { Tab, Nav } from 'react-bootstrap';

import Watch from '@/pages/dashboard/sections/watch'
import Evaluate from '@/pages/dashboard/sections/evaluate'
import History from '@/pages/dashboard/sections/history'
import FavVideos from '@/pages/dashboard/sections/fav'
import { addCurrentThemeClassToEle, makeFirstLetterCapsAndRemoveUnderScore } from "@/utils"
import './desktopViewStyle.css';
import '@/styles/commonContainer.css'
import { useSelector } from 'react-redux';
import { RootState } from '@/store';
export default function DashboardView(props: any) {

    const currentTheme = useSelector((state: RootState) => state.currentThemeReducer.currentTheme);

    return (
        <div className={`commonContainer dashboardDesktopMain ${addCurrentThemeClassToEle(currentTheme, 'dashboardDesktopMain')}`}>
            <Tab.Container activeKey={props.activeKey} onSelect={(k) => k && props.handleIntSetActiveKey(k)}>
                <Nav variant="tabs" className={`${addCurrentThemeClassToEle(currentTheme, 'navConDesktop')}`}>
                    {props.tabs.map((tab: any, index: number) => (
                        <Nav.Item key={tab.key}>
                            <Nav.Link
                                style={index > 0 ? { marginLeft: '20px' } : {}}
                                eventKey={tab.key}
                                // className={`flex items-center ${props.activeKey === tab.key ? 'text-primary' : 'text-dark'
                                //     }`}
                                className={`flex items-center`}
                            >

                                <img
                                    // src={props.activeKey === tab.key ? tab.hoverIcon : tab.defaultIcon}
                                    src={props.getCurrentNavIconSrc(props.activeKey, tab)}
                                    alt={`${props.dashboard.tabs[tab.key]} icon`}
                                    className="navIcon mr-2 w-[25px] h-auto"
                                />
                                {makeFirstLetterCapsAndRemoveUnderScore(props.dashboard.tabs[tab.key])}
                                {/* {props.dashboard.tabs[tab.key]} */}
                            </Nav.Link>
                        </Nav.Item>
                    ))}
                </Nav>

                <Tab.Content className={`py-[30px] px-[30px] rounded-bl-[10px] rounded-br-[10px] ${addCurrentThemeClassToEle(currentTheme, 'dashboardDesktopMain_TabContent')}`}>
                    {props.tabs.map((tab: any) => (
                        <Tab.Pane eventKey={tab.key} key={tab.key}>
                            {/* <p className="">You're viewing the <strong>{props.dashboard.tabs[tab.key]}</strong> tab.</p> */}
                            {tab.key === "watch" &&
                                <Watch
                                    activeKey={props.activeKey}
                                />
                            }
                            {tab.key === "evaluate" &&
                                <Evaluate
                                    activeKey={props.activeKey}
                                />
                            }
                            {tab.key === "history" &&
                                <History
                                    activeKey={props.activeKey}
                                />
                            }
                            {tab.key === "favorite" &&
                                <FavVideos
                                    activeKey={props.activeKey}
                                />
                            }
                        </Tab.Pane>
                    ))}
                </Tab.Content>
            </Tab.Container>
        </div>
    );
}
